import { Map as IMap, List as IList } from 'immutable';

export const selectUploadedCatalog = (state) => state.companyCatalogReducer.get('uploadedCatalog', IMap());
export const selectCatalogs = (state) => state.companyCatalogReducer.get('catalogs', IList());
